<div class="deployment-pending-page">
    <div class="deployment-pending-card">
        <img *ngIf="_globals.whiteLabel?.logo" [src]="_globals.whiteLabel.logo" alt="logo" class="deployment-pending-logo" />

        <ng-container *ngIf="!timedOut">
            <div class="deployment-pending-spinner"><i class="pi pi-spin pi-spinner"></i></div>
            <h2>Setting up your account</h2>
            <p>{{ waitingMessage }}</p>
        </ng-container>

        <ng-container *ngIf="timedOut">
            <h2>Still working on it</h2>
            <p>This is taking longer than usual. You'll get an email once your account is ready — or you can check again now.</p>
            <button pButton type="button" label="Check again" (click)="retryNow()"></button>
        </ng-container>
    </div>
</div>
